// Adapted from https://github.com/CharlesStover/use-dimensions/pull/4
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import debounce from "lodash/debounce";
import { createContext, useContext, useEffect, useState } from "react";
import { Dimensions as RNDimensions } from "react-native";
export var FakeDimensionsContext = createContext(null);
// adapted from https://github.com/necolas/react-native-web/blob/master/packages/react-native-web/src/exports/useWindowDimensions/index.js
var _useDimensions = function(type, debounceMs) {
    var fakeDimensions = useContext(FakeDimensionsContext);
    var _useState = _sliced_to_array(useState(function() {
        return RNDimensions.get(type);
    }), 2), dimensions = _useState[0], setDimensions = _useState[1];
    useEffect(function() {
        var debouncedSetDimensions = debounceMs ? debounce(setDimensions, debounceMs) : setDimensions;
        // Event listener for when the dimensions change.
        var handleDimensionsChange = function(param) {
            var window = param.window, screen = param.screen;
            var newDimensions = type === 'screen' ? screen : window;
            debouncedSetDimensions(_object_spread({}, newDimensions));
        };
        var listener = RNDimensions.addEventListener('change', handleDimensionsChange);
        // We might have missed an update between calling `get` in render and
        // `addEventListener` in this handler, so we set it here. If there was
        // no change, React will filter out this update as a no-op.
        debouncedSetDimensions(RNDimensions.get(type));
        // When the component unmounts, remove the event listener.
        return function() {
            listener.remove();
        };
    }, [
        dimensions,
        type,
        debounceMs
    ]);
    return fakeDimensions !== null && fakeDimensions !== void 0 ? fakeDimensions : dimensions;
};
export function useScreenDimensions() {
    return _useDimensions('screen', 20);
}
export function useWindowDimensions() {
    return _useDimensions('window', 20);
}
export default function useDimensions() {
    var screen = useScreenDimensions();
    var window = useWindowDimensions();
    return {
        screen: screen,
        window: window
    };
}
